import { createUseStyles } from 'react-jss';

import { ITheme } from 'types';
import { zDropdownContent } from 'utils/ui-helpers/stackingContexts';

const useStyles = createUseStyles((theme: ITheme) => ({
  'pw-dropdown': {
    position: 'relative',
    outline: 'none',
    width: 'fit-content !important',
    display: 'flex',
    flexDirection: 'column',
  },
  'pw-dropdown_label': {
    position: 'relative',
    fontSize: 14,
    fontWeight: 500,
    cursor: 'pointer',
    textAlign: 'center',
    padding: `${theme.spacings.s0} ${theme.spacings.s8} ${theme.spacings.s0} ${theme.spacings.s16}`,
    display: 'flex',
    alignItems: 'center',
    width: 'fit-content',
    background: '#f9f9fe',
    borderRadius: theme.variables.mainBorderRadius,

    '&:before': {
      content: '""',
      position: 'absolute',
      top: -1,
      left: -1,
      width: 'calc(100% + 2px)',
      height: 'calc(100% + 2px)',
      border: '1px solid #dcdde9',
      borderRadius: 10,
    },
    '&:hover': {
      '&:before': {
        border: '1px solid #282b36',
      },
    },
    '& svg': {
      transition: 'transform .3s',
      transform: 'rotate(0deg)',
    },
    '& span': {
      marginInlineEnd: 4,
    },
  },
  active: {
    background: '#ffffff',
    '&:before': {
      border: '1px solid #3a76e8',
    },
    '& svg': {
      transform: 'rotate(180deg)',
    },
  },
  'pw-dropdown_content': {
    position: 'absolute',
    zIndex: zDropdownContent,
    border: '1px solid rgba(151, 151, 151, .48)',
    background: '#ffffff',
    borderRadius: theme.variables.mainBorderRadius,
    padding: `${theme.spacings.s8} ${theme.spacings.s0}`,
  },
  'pw-dropdown_content_divider': {
    width: '100%',
    height: 1,
    backgroundColor: '#dcdde9',
    margin: `${theme.spacings.s8} ${theme.spacings.s0}`,
  },
  'pw-dropdown_content_right': {
    right: theme.spacings.s0,
  },
  'pw-dropdown_content_left': {
    left: theme.spacings.s0,
  },
  'pw-dropdown_content_center': {
    left: '50%',
    transform: 'translateX(-50%)',
  },
  'pw-dropdown_content_top': {
    bottom: 50,
  },
  'pw-dropdown_content_bottom': {
    top: 50,
  },
  'pw-dropdown_content_main': {
    display: 'flex',
    flexDirection: 'column',
  },
  'pw-dropdown_content_item': {
    alignItems: 'center',
    display: 'flex',
    cursor: 'pointer',
    justifyContent: 'space-between',
    padding: `${theme.spacings.s0} ${theme.spacings.s8}`,
    '& span': {
      color: '#282b36',
      paddingLeft: 16,
      borderRadius: theme.variables.mainBorderRadius,
      fontWeight: 500,
    },
    '&:hover': {
      '& span': {
        backgroundColor: '#edeef499',
      },
    },
  },
  'pw-dropdown_content_item-selected': {
    backgroundColor: '#edeef4',
  },
  'pw-dropdown_large': {
    height: 48,
    fontSize: 14,
    lineHeight: '48px',
  },
  'pw-dropdown_medium': {
    height: 40,
    width: 96,
    fontSize: 14,
    lineHeight: '40px',
  },
  'pw-dropdown_small': {
    height: 32,
    fontSize: 12,
    lineHeight: '32px',
  },
  'pw-dropdown_mini': {
    height: 28,
    fontSize: 12,
    lineHeight: '28px',
  },
  large: {
    height: 48,
    fontSize: 14,
    lineHeight: '48px',
  },
  dropdownArrow: {
    verticalAlign: 'top',
    display: 'inline-block',
    width: theme.variables.iconSize,
    height: theme.variables.iconSize,
  },
}));

export default useStyles;
